import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const jiraWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-jira/web/JiraPage',
    label: 'Run agents on Jira tickets and open PRs for the work.',
  },
  eventLabels: [
    {
      type: 'agent.source.jira_issue',
      label: 'Jira issue',
      tooltip: 'Agent triggered from a Jira issue',
      style: 'system',
    },
  ],
  // Jira launches agents stamped with a `jrr_*` run id as their originator, so
  // the agent list's originator/type filter can offer "Jira" as a kind.
  originators: [{ idPrefix: 'jrr', label: 'Jira' }],
  // Chip for the `jira_issue` association kind this plugin provides (see
  // `associationKinds` in the plugin definition): rendered wherever an
  // agent's linked work items show.
  associationChips: [
    {
      kind: 'jira_issue',
      label: 'Jira issue',
      componentPath: '@reflex/plugin-jira/web/JiraAssociationChip',
    },
  ],
  // `@jira:` context category in the launch and chat composers. Selecting
  // an issue inserts a `jira-issue` reference chip that the server resolver
  // registered in `register()` expands into the issue's full content.
  agentContextProviders: [
    {
      id: 'agent-context-jira-issues',
      kind: 'jira-issue',
      label: 'Jira issues',
      keyword: 'jira',
      icon: 'CheckSquare',
      componentPath: '@reflex/plugin-jira/web/JiraIssueContextProvider',
      order: 60,
    },
  ],
};
